
import ProductPriceOnDemand from '@/components/modal/ProductPriceOnDemand'

export default {
  components: {
    ProductPriceOnDemand,
  },
  data() {
    return {
      priceOnDemandShow: false,
      itemName: '',
      swiperOptions: {
        slidesPerView: 1.5,
        spaceBetween: 10,
        observer: true,
        observeParents: true,
        loop: false,
        breakpoints: {
          1024: {
            slidesPerView: 5,
            spaceBetween: 32,
          },
          720: {
            slidesPerView: 3,
            spaceBetween: 32,
          },
          500: {
            slidesPerGroup: 2.5,
            slidesPerView: 3,
            spaceBetween: 28,
          },
        },
      },
    }
  },
  methods: {
    openContactForm(productName) {
      this.priceOnDemandShow = true
      this.itemName = productName
    },
    checkIfProductIsInCijenaNaUpitCategory(categories = [], productName) {
      if (!categories || !categories.length) return false
      return categories
        .map((el) => el.id)
        .some((el) => {
          return [1028, 1620].includes(el)
        })
    },
  },
}
